export default {
  static_qr_id: '静态二维码编号',
  create_static_qr: '创建静态二维码',
  qr_thumbnail: 'QR 缩略图',
  qr_code_detail: '静态二维码详情',
  qr_link: '二维码链接',
  tag: '标签',
  enter_remark: '输入备注',
  enter_tag: '输入标签',
  download_qr_code: '下载静态二维码',
  example: '示例（仅供参考）:',
  view_transaction_details: '查看交易详情',
}